import {
    TOP_GAMES_INIT,
    TOP_GAMES_LOADING,
    TOP_GAMES_BY_PRICE_POINT,
    TOP_GAMES_ERROR,
} from '../../../../actions/retailerDashboard/widgets/topGames/topGames';

const INITIAL_STATE = {
    topGamesByPricePoint: undefined,
    loading: false,
    errorResponse: null,
};

const topGames = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TOP_GAMES_INIT:
            return { ...INITIAL_STATE };
        case TOP_GAMES_LOADING:
            return { ...state, loading: true };
        case TOP_GAMES_BY_PRICE_POINT:
            return {
                ...state,
                topGamesByPricePoint: [...action.topGamesByPricePoint],
                loading: false,
                errorResponse: null,
            };
        case TOP_GAMES_ERROR:
            return {
                ...state,
                loading: action.loading,
                errorResponse: action.errorResponse,
            };
        default:
            return state;
    }
};
export default topGames;
